import React, { useState } from "react";
import { HelpCircle, Megaphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Dialog, DialogContent, DialogPortal, DialogOverlay } from "@/components/ui/dialog";
import { FeedbackDialog } from "./FeedbackDialog";

export const FeedbackButton = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <>
      <DropdownMenu open={isDropdownOpen} onOpenChange={setIsDropdownOpen}>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 rounded-full"
          >
            <HelpCircle className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem 
            className="px-3 py-2"
            onSelect={(event) => {
              event.preventDefault();
              setIsDropdownOpen(false);
              setIsDialogOpen(true);
            }}
          >
            Feedback <Megaphone className="ml-3 h-4 w-4" />
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogPortal>
          <DialogOverlay className="bg-background/80 backdrop-blur-sm" />
          <DialogContent className="sm:max-w-[425px] pt-10">
            <FeedbackDialog onClose={() => setIsDialogOpen(false)} />
          </DialogContent>
        </DialogPortal>
      </Dialog>
    </>
  );
};